// @ts-nocheck
import debounce from "lodash/debounce";
import { useMemo, useRef } from "react";

type SomeFunction = (...args: never[]) => unknown;
export type DebouncedFunction<Func extends SomeFunction> = ((
    ...args: Parameters<Func>
) => ReturnType<Func> | undefined) & {
    cancel: () => void;
    flush: () => ReturnType<Func> | undefined;
};

export function useDebounce<Func extends SomeFunction>(func: Func, delay = 1000): DebouncedFunction<Func> {
    const funcRef = useRef(func);
    funcRef.current = func;

    const debouncedFunc = useMemo(
        () =>
            debounce(
                (...args: Parameters<Func>): ReturnType<Func> => funcRef.current(...args) as ReturnType<Func>,
                delay,
            ),
        [delay],
    );

    return debouncedFunc;
}
